import { render, staticRenderFns } from "./infoMsg.vue?vue&type=template&id=44d4ba72&scoped=true&"
import script from "./infoMsg.vue?vue&type=script&lang=js&"
export * from "./infoMsg.vue?vue&type=script&lang=js&"
import style0 from "./infoMsg.vue?vue&type=style&index=0&id=44d4ba72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d4ba72",
  null
  
)

export default component.exports